import React from 'react';

export function RoutedPageFallback(): React.JSX.Element {
  return (
    <div
      className="min-h-[40vh] bg-brand-bg"
      aria-hidden="true"
      data-testid="routed-page-fallback"
    />
  );
}
